class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('focus', () => this.loadBrandNames(), { once: true });
      this.input.form.addEventListener('submit', async (event) => {
        if (SearchForm.brandNamesReady || !this.input.value.trim() || this.querySelector('[aria-selected="true"] a')) return;
        event.preventDefault();
        await this.loadBrandNames();
        if (event.submitter) this.input.form.requestSubmit(event.submitter);
        else this.input.form.requestSubmit();
      });
      this.input.form.addEventListener('formdata', (event) => {
        event.formData.set('q', this.getSearchQuery(this.input.value));
      });
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }


  loadBrandNames() {
    if (!SearchForm.brandNamesPromise) {
      const config = JSON.parse(document.getElementById('sv-search-brands')?.textContent || '{}');
      SearchForm.brandNamesPromise = (config.url ? fetch(config.url).then((response) => {
        if (!response.ok) throw new Error('Brand list unavailable');
        return response.text();
      }).then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        return Array.from(parsed.querySelectorAll('[data-sv-available-brands] a'), (link) => link.textContent.trim());
      }).catch(() => []) : Promise.resolve([])).then((brands) => {
        SearchForm.brandNames = brands;
        SearchForm.brandNamesReady = true;
        return brands;
      });
    }
    return SearchForm.brandNamesPromise;
  }

  getSearchQuery(value) {
    const query = value.trim();
    if (!query || /[\s:"]/u.test(query)) return query;
    const normalize = (text) => text.normalize('NFKC').toLowerCase().replace(/\s+/g, ' ').trim();
    const term = normalize(query);
    const excluded = new Set(['collection', 'collezioni', 'couture', 'boutique', 'label', 'chic', 'marcus']);
    const brands = SearchForm.brandNames || [];
    const matched = !excluded.has(term) && term.length >= 3 && brands.some((brand) => {
      const primary = normalize(brand).split(' for ')[0];
      return primary === term || primary.split(' ').at(-1) === term;
    });
    return matched ? 'title:' + query : query;
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
